import type { MarketplaceAppOverview } from 'types/client/marketplace';
import type { SearchResultItem } from 'types/client/search';

import config from 'configs/app';
import type { MessageParams } from 'lib/i18n/core';

export type ApiCategory = 'token' | 'nft' | 'address' | 'public_tag' | 'transaction' | 'block' | 'user_operation' | 'blob' | 'domain';
export type Category = ApiCategory | 'app';

export type ItemsCategoriesMap =
Record<ApiCategory, Array<SearchResultItem>> &
Record<'app', Array<MarketplaceAppOverview>>;

export type SearchResultAppItem = {
  type: 'app';
  app: MarketplaceAppOverview;
};

export type SearchCategoryTab = {
  id: Category;
  titleKey: string;
  titleParams?: MessageParams;
};

const tokenStandard = config.chain.tokenStandard;

export const searchCategories: Array<SearchCategoryTab> = [
  { id: 'app', titleKey: 'search.categories.app' },
  { id: 'token', titleKey: 'search.categories.token', titleParams: { tokenStandard } },
  { id: 'nft', titleKey: 'search.categories.nft', titleParams: { tokenStandard } },
  { id: 'address', titleKey: 'search.categories.address' },
  { id: 'public_tag', titleKey: 'search.categories.public_tag' },
  { id: 'transaction', titleKey: 'search.categories.transaction' },
  { id: 'block', titleKey: 'search.categories.block' },
];

if (config.features.userOps.isEnabled) {
  searchCategories.push({ id: 'user_operation', titleKey: 'search.categories.user_operation' });
}

if (config.features.dataAvailability.isEnabled) {
  searchCategories.push({ id: 'blob', titleKey: 'search.categories.blob' });
}

if (config.features.nameService.isEnabled) {
  searchCategories.unshift({ id: 'domain', titleKey: 'search.categories.domain' });
}

export function searchItemTypeFullKey(category: Category): string {
  return `search.itemTypes.${ category }.full`;
}

export function searchItemTypeShortKey(category: Category): string {
  return `search.itemTypes.${ category }.short`;
}

export function getItemCategory(item: SearchResultItem | SearchResultAppItem): Category | undefined {
  switch (item.type) {
    case 'address':
    case 'contract': {
      return 'address';
    }
    case 'token': {
      if (item.token_type === 'ERC-20') {
        return 'token';
      }
      return 'nft';
    }
    case 'block': {
      return 'block';
    }
    case 'label': {
      return 'public_tag';
    }
    case 'transaction': {
      return 'transaction';
    }
    case 'app': {
      return 'app';
    }
    case 'user_operation': {
      return 'user_operation';
    }
    case 'blob': {
      return 'blob';
    }
    case 'ens_domain': {
      return 'domain';
    }
  }
}
